import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SettingsComponent} from './settings.component';
import {HolidaysComponent} from './holidays/holidays.component';
import {UiKitsModule} from 'src/app/shared/ui-kits/ui-kits.module';
import {SettingsRoutingModule} from './settings-routing.module';
import {HolidaysModalComponent} from './holidays/holidays-modal/holidays-modal.component';
import {ReactiveFormsModule} from '@angular/forms';
import {OfficesComponent} from './offices/offices.component';
import {OfficeModalComponent} from './offices/office-modal/office-modal.component';
import {AsteriskModule} from 'src/app/directives/mark-asterisk/mark-asterisk.module';
import {TechStacksAndPositionsComponent} from './tech-stacks-and-positions/tech-stacks-and-positions.component';
import {AddingModalComponent} from './tech-stacks-and-positions/adding-modal/adding-modal.component';
import {PositionModalComponent} from './tech-stacks-and-positions/position-modal/position-modal.component';

@NgModule({
  declarations: [
    SettingsComponent,
    HolidaysComponent,
    HolidaysModalComponent,
    OfficesComponent,
    OfficeModalComponent,
    TechStacksAndPositionsComponent,
    AddingModalComponent,
    PositionModalComponent,
  ],
  imports: [
    CommonModule,
    UiKitsModule,
    SettingsRoutingModule,
    ReactiveFormsModule,
    AsteriskModule,
  ],
})
export class SettingsModule {}
